/**
 * ArrowForwardIcon — 16×16 forward arrow for the subscription cards.
 *
 * Fill defaults to the theme token `--button-functional-content-skeleton`,
 * applied via the `arrow-forward-icon` className so it stays theme-aware. Pass
 * `color` to override the fill (used by the pending/warning card variant).
 */
const ArrowForwardIcon = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.819 13.348a1.035 1.035 0 0 1 0-1.518L9.866 9H3a1 1 0 0 1 0-2h6.867L6.818 4.17A1.035 1.035 0 0 1 8.226 2.65l4.982 4.615a1 1 0 0 1 0 1.468l-4.982 4.614a1.035 1.035 0 0 1-1.407 0z"
        className="arrow-forward-icon"
        {...(color ? { fill: color } : {})}
      />
    </svg>
  );
};

export default ArrowForwardIcon;
